module.exports = __webpack_public_path__ + "static/media/scale-icon.825b72a2.svg";